var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSpacesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V18C0.5 19.1046 1.39543 20 2.5 20H5.5C6.60457 20 7.5 19.1046 7.5 18V2C7.5 0.89543 6.60457 0 5.5 0Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5H2.5C1.67157 0.5 1 1.17157 1 2V18C1 18.8284 1.67157 19.5 2.5 19.5H5.5C6.32843 19.5 7 18.8284 7 18V2C7 1.17157 6.32843 0.5 5.5 0.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H10.5C9.39543 0 8.5 0.89543 8.5 2V6C8.5 7.10457 9.39543 8 10.5 8H13.5C14.6046 8 15.5 7.10457 15.5 6V2C15.5 0.89543 14.6046 0 13.5 0Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5H10.5C9.67157 0.5 9 1.17157 9 2V6C9 6.82843 9.67157 7.5 10.5 7.5H13.5C14.3284 7.5 15 6.82843 15 6V2C15 1.17157 14.3284 0.5 13.5 0.5Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9H10.5C9.39543 9 8.5 9.89543 8.5 11V18C8.5 19.1046 9.39543 20 10.5 20H13.5C14.6046 20 15.5 19.1046 15.5 18V11C15.5 9.89543 14.6046 9 13.5 9Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5H10.5C9.67157 9.5 9 10.1716 9 11V18C9 18.8284 9.67157 19.5 10.5 19.5H13.5C14.3284 19.5 15 18.8284 15 18V11C15 10.1716 14.3284 9.5 13.5 9.5Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSpacesOperationIcon);
export default __webpack_public_path__ + "static/media/ManageSpacesOperationIcon.ad2571c4d96cfccc9a76832ed3d6488c.svg";
export { ForwardRef as ReactComponent };